import React, { useState, useEffect, useRef } from 'react';
import Export from "../../../assets/images/export.svg";
import pen from "../../../assets/images/pen.png";
import info from "../../../assets/images/info.png";
import Arcv from "../../../assets/images/archive.svg";
import Activ from "../../../assets/images/active.svg";
import { Button, Modal, Form, Tabs, Tab, Card, InputGroup } from 'react-bootstrap';
import Info_edit from "../../../assets/images/unverified_fill.png";
import green_check from "../../../assets/images/verified_fill.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faXmark, faUpload, faPaperclip, faDownload, faCircleXmark, faLink, faCircleCheck, faChevronDown, faPencil, } from '@fortawesome/free-solid-svg-icons';
import DownloadGrid from './common/DownloadGrid.js';
import { withDVRToken, withRFSToken } from '../../../Services/axios.js';
import { toast } from 'react-toastify';
import ConfModal from '../../../Components/common/ConfModal.js';
import { getTodayDateTime, applyOffsetToDateTime, jqxCookieCall } from '../../../Components/common/CommonFunctions.js';
import Select from 'react-select';
import loading_icon from '../../../assets/images/truck_loading.png';
import unloading_icon from '../../../assets/images/truck_unloading.png';
import axios from 'axios';
import { LogOut } from '../../Auth/LogOut.js';
const Driver = () => {

    const getTz = JSON.parse(localStorage.getItem('timeZone') || 'null');
    const isMounted = useRef(false);
    const inputRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [gridData, setGridData] = useState({ Active: [], Archived: [], });
    const [gridSelect, setGridSelect] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
    };
    const [activeTab, setActiveTab] = useState('Active');
    const [downloadModal, setDownloadModal] = useState(false);
    const openDownloadModal = () => setDownloadModal(true);
    const closeDownloadModal = () => setDownloadModal(false);

    const [editModal, setEditModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedField, setSelectedField] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [dateTimeValue, setDateTimeValue] = useState("");

    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});
    const [disLoading, setDisLoading] = useState(false);
    const [loadingType, setLoadingType] = useState();
    const [view, setView] = useState("menu");
    const orgLogo = localStorage.getItem('orgLogo');
    const [signatureMode, setSignatureMode] = useState("draw");
    const sigPadRef = useRef(null);
    const [typedSignature, setTypedSignature] = useState("");
    const [loading, setLoading] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [dialCode, setDialCode] = useState();

    const [driverForm, setDriverForm] = useState({
        company_name: "",
        first_name: "",
        surname: "",
        id_number: "",
        id_type: "",
        license: "",
        number: "",
        // phone: "",
        loading_or_unloading: "",
    });

    const resetDriverForm = () => {
        setDriverForm({
            company_name: "",
            first_name: "",
            surname: "",
            id_number: "",
            id_type: "",
            license: "",
            number: "",
            loading_or_unloading: "",
        });
        setDialCode("");
        setSignatureMode("draw");
        setTypedSignature("");
        if (sigPadRef.current) sigPadRef.current.clear();
        setLoadingType(""); // reset loading/unloading buttons
    };



    useEffect(() => {
        const interval = setInterval(() => {
            window.location.reload();
        }, 300000);

        if (!isMounted.current) {
            setIsLoading(false);
            setGridData([]);
            isMounted.current = true;
        }

        return () => clearInterval(interval);
    }, []);

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }
    };

    const handleDriverChange = (e) => {
        const { name, value } = e.target;
        setDriverForm((prev) => ({ ...prev, [name]: value }));
    };

    let checkUlds = [];
    useEffect(() => {
        if (gridRefs[activeTab].current) {
            // var token = "Bearer " + localStorage.DVR;
            jqxCookieCall();
            let tabType = '';
            if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'R' }
            const source = {
                url: `${process.env.REACT_APP_RFS_URL}vehicle-management/list-drivers?tab=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'company_name', type: 'string' },
                    { name: 'first_name', type: 'string' },
                    { name: 'surname', type: 'string' },
                    { name: 'id_expiry', type: 'string' },
                    { name: 'is_verified', type: 'string' },
                    { name: 'license', type: 'string' },
                    { name: 'cmr', type: 'string' },
                    { name: 'loading_or_unloading', type: 'string' },
                    { name: 'signature_text', type: 'string' },
                    { name: 'id_type', type: 'string' },
                    { name: 'attachments', type: 'string' },
                    { name: 'created_at', type: 'string' },
                    { name: 'checkout_date', type: 'string' },
                    { name: 'trucker_plate', type: 'string' },
                    { name: 'trailer_plate', type: 'string' },
                ],
                filter: function (allfilters) {
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    setGridSelect([]);
                    if (allfilters.length > 0) {
                        console.log("Filter Applied");
                        setFilterApplied(true);
                    } else {
                        console.log("Filter Cleared");
                        setFilterApplied(false);
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
                // localdata: gridData,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                { text: 'Company Name', datafield: 'company_name', width: '8%' },
                { text: 'First Name', datafield: 'first_name', width: '8%' },
                { text: 'Last Name', datafield: 'surname', width: '8%' },
                { text: 'ID Type', datafield: 'id_type', width: '8%' },
                { text: 'ID Expiry', datafield: 'id_expiry', width: '6%' },
                {
                    text: 'ID Check', datafield: 'is_verified', width: '7%',
                    cellsrenderer: function (row, columnfield, value, defaultHtml) {
                        if (activeTab === 'Active') {
                            if (value == 1) {
                                defaultHtml =
                                    '<div class="set_check verified screen1" data-field="is_verified" data-type="uncheck">' +
                                    '<span>' +
                                    '<img src="' + green_check + '" class="" /> Verified' +
                                    '</span>' +
                                    '</div>';
                            } else {
                                defaultHtml =
                                    '<div class="set_check screen1" data-field="is_verified" data-type="check">' +
                                    '<span>' +
                                    '<img src="' + Info_edit + '" class="" /> Unverified' +
                                    '</span>' +
                                    '</div>';
                            }
                        } else if (activeTab == 'Archived') {
                            if (value == 1) {
                                defaultHtml =
                                    '<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">Checked</div>';
                            } else {
                                defaultHtml =
                                    '<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">Unchecked</div>';
                            }
                        }

                        return defaultHtml;
                    }
                },
                { text: 'Doc Reference', datafield: 'cmr', width: '7%' },

                { text: 'License Plate', datafield: 'license', width: '7%' },
                // { text: 'Trucker ID Plate', datafield: 'trucker_plate', width: '10%' },
                { text: 'Trailer ID', datafield: 'trailer_plate', width: '7%' },
                { text: '(Un) Loading', datafield: 'loading_or_unloading', width: '7%' },
                {
                    text: 'Date Time In',
                    datafield: 'created_at',
                    width: '8%',
                    cellsrenderer: function (row, columnfield, value) {
                        const formatted = applyOffsetToDateTime(value, "L");
                        return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${formatted}</div>`;
                    }
                },
                {
                    text: 'Date Time Out',
                    datafield: 'checkout_date',
                    width: '11%',
                    cellsrenderer: function (row, columnfield, value, defaultHtml) {
                        // if (!value) {
                        //     return `<div class="set_fn" data-field="checkout_date" >
                        //         <img src="${pen}" class="row_edit" /> Set
                        //     </div>`;
                        // }

                        const date = new Date(value);
                        const formatted = date.toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false
                        });
                        if (activeTab === 'Active') {
                            if (value) {
                                defaultHtml = '<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">' + value + '<span class="screen" data-field="checkout_date"><img src="' + pen + '" class="" /></span></div>';
                            } else {
                                defaultHtml = '<div class="set_fn" data-type="add" data-for="get_in"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
                            }
                        } else if (activeTab === 'Archive') {
                            defaultHtml = '<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">' + formatted + '</div>';
                        }
                        return defaultHtml;
                    }
                },
                {
                    text: 'Signature',
                    datafield: 'signature_text',
                    width: '4%',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;"><img class="signature-info-icon"  src="${info}" /></div>`;
                    }
                }
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                height: 1040,
                columns: columns,
                autoheight: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                selectionmode: 'checkbox', // checkbox
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
            };

            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                // console.log('event', args)
                if (event.args.columnindex > -1) {

                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                    }
                    // loadDetails(args.awb_id);
                    // setSelectedRowData(args);
                }
            });
            window.$(gridRefs[activeTab].current).on('click', '.signature-info-icon', function () {
                setShowModal(true)
            });

            window.$(gridRefs[activeTab].current).on('click', '.set_fn,.screen', function () {
                if (activeTab !== 'Active') {
                    return;
                }
                const field = window.$(this).attr("data-field");
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                setSelectedField(field);
                setSelectedRow(rowData);

                // If data exists → set that value
                if (rowData && rowData[field]) {
                    // setDateTimeValue(new Date(rowData[field]).toISOString().slice(0, 16));
                    setDateTimeValue(rowData[field])
                } else {
                    // Else current datetime
                    // setDateTimeValue(new Date().toISOString().slice(0, 16));
                    setDateTimeValue(getTodayDateTime());
                }

                setEditModal(true);
            });
            window.$(gridRefs[activeTab].current).on('click', '.screen1', function () {
                const field = window.$(this).attr("data-field");
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                // console.log("rowdata",rowData)
                setConfData({
                    header: rowData?.is_verified == 0 ? "ID Verified ?" : "ID Unverified ?",
                    // subHeader:
                    //     rowData?.is_verified == 0
                    //         ? "Are you sure you want to verify?"
                    //         : "Are you sure you want to unverify?",
                    primaryBtn: "Yes",
                    secondaryBtn: "No",
                    modalConf: () => verifiedConf(rowData?.id),
                });
                setModalConf(true);
            });

            // }
        }
    }, [gridData]);

    const [linkModal, setLinkModal] = useState(false);
    const [addDriverModal, setAddDriverModal] = useState(false)
    let token = localStorage.DVR;
    // const [dvLink, setDvLink] = useState(`${process.env.REACT_APP_MAIN_URL}?no_token=${token}&person=D`);
    const [dvLink, setDvLink] = useState();
    const [originalLink, setOriginalLink] = useState('');
    const [bothAccess, setBothAccess] = useState(false);

    const updatePersonInUrl = (link, personValue) => {
        try {
            const urlObj = new URL(link);
            urlObj.searchParams.set('person', personValue);
            return urlObj.toString();
        } catch (e) {
            return link;
        }
    }

    const idTypeOptions = [
        { value: "Driver License", label: "Driver License" },
        { value: 'Passport', label: 'Passport' },
    ];


    const openModal = async () => {
        // setLinkModal(true);
        try {
            const res = await withRFSToken.post('vehicle-management/generate-link', { type: 'Driver' });
            const innerData = res?.data?.response_data;
            if (res.data.response_code === 200) {
                const innerData = res?.data?.response_data;
                // setDvLink(innerData.link)
                // setOriginalLink(innerData.link)
                setDvLink(innerData?.link)
                setOriginalLink(innerData?.link)
                setBothAccess(false)
                setLinkModal(true);
            } else {
                toast.error(res.data.response_msg)
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
            // toast.error('Failed to load settings');
        }
    }

    const openDriverModal = () => {
        setAddDriverModal(true)
    }


    const closeConfirm = () => {
        setLinkModal(false);
    }

    const closeDriverConfirm = () => {
        setAddDriverModal(false)
    }

    const handleCopy = () => {
        if (inputRef.current) {
            inputRef.current.select();
            inputRef.current.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(inputRef.current.value);
            //   console.log("Copied: " + inputRef.current.value);
        }
    };
    const saveDateTime = async () => {

        try {
            const token = "Bearer " + localStorage.DVR;
            const payload = {
                id: selectedRow.id,
                type: "Driver",
            };
            if (selectedField === "checkin_date") {
                payload.checkin_date = formatDateTime(dateTimeValue);
            } else {
                payload.checkout_date = formatDateTime(dateTimeValue);
            }
            const res = await withRFSToken.post('vehicle-management/set-checkout-in-time', payload);
            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
            setEditModal(false);
        } catch (error) {
            console.error("Save Failed:", error.response?.data || error.message);
            alert("Failed to update. Please try again.");
        }
    };

    const formatDateTime = (value) => {
        const date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const activateLink = () => {
        const url = inputRef.current.value;
        // const logoutUrl = localStorage.getItem('LogOut');
        if (url) {
            window.open(
                url,
                '_blank', // always opens in a new tab/window
                'noopener,noreferrer,width=1000,height=800' // optional features
            );
        }
        localStorage.clear();
        // window.location.replace(logoutUrl);
        LogOut();
    };
    const regenerateLink = async () => {
        try {
            setDisLoading(true);
            const res = await withRFSToken.post('vehicle-management/generate-org-passcode', { type: 'Driver' });
            if (res.data.response_code === 200) {
                const innerData = res?.data?.response_data;
                setDvLink(innerData?.passcode);
                setOriginalLink(innerData?.passcode);
                toast.success('Passcode regenerated successfully');
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error regenerating link:', error);
            toast.error('Failed to regenerate passcode');
        } finally {
            setDisLoading(false);
            // setLinkModal(false);
        }
    };

    const handleRegenerateConfirm = () => {
        setConfData({
            header: "Regenerate Passcode",
            subHeader: "Are you sure you want to regenerate the passcode?",
            primaryBtn: "Yes",
            secondaryBtn: "No",
            modalConf: regenerateLink,
        });
        setModalConf(true);
    };

    const validateDriverForm = () => {
        if (!driverForm.company_name?.trim()) {
            toast.error("Company Name is required");
            return false;
        }
        if (!driverForm.first_name?.trim()) {
            toast.error("Driver First Name is required");
            return false;
        }
        if (!driverForm.surname?.trim()) {
            toast.error("Driver Last Name is required");
            return false;
        }
        if (!driverForm.id_type) {
            toast.error("ID Type is required");
            return false;
        }
        if (!driverForm.id_expiry) {
            toast.error("ID Expiry is required");
            return false;
        }
        if (!driverForm.license?.trim()) {
            toast.error("License Plate No. is required");
            return false;
        }
        if (!loadingType) {
            toast.error("Please select Loading or Unloading");
            return false;
        }
        if (!driverForm.cmr?.trim()) {
            toast.error("Document Reference is required");
            return false;
        }
        return true;
    };
    const handleDriverSubmit = async () => {
        if (!validateDriverForm()) return;
        try {
            const payload = {
                ...driverForm,
                loading_or_unloading: loadingType,
            };
            const res = await withRFSToken.post(`${process.env.REACT_APP_RFS_URL}vehicle-management/save-driver`, payload,);
            if (res.data?.response_code === 200) {
                const msg = res.data?.response_msg || "Driver saved successfully!";
                toast.success(msg);
                setAddDriverModal(false);
                window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
            } else {
                const msg = res.data?.response_msg || "Error saving driver";
                toast.error(msg);
                console.warn("Driver save business error:", res.data);
            }
        } catch (err) {
            console.error("Driver save error:", err.response?.data || err.message);
            toast.error("Error saving driver");
        } finally {
            setLoading(false);
            setAddDriverModal(false);
        }
    };

    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    };

    const handleMoveToActArc = () => {
        if (!gridSelect.length) {
            toast.error('Please select row first');
            return;
        }
        setConfData({
            header: `Selected Data move to ${activeTab == 'Active' ? 'Archive' : 'Active'}`,
            subHeader: `'Are you sure you want to ${activeTab == 'Active' ? 'Archive' : 'Active'}?`,
            primaryBtn: 'Confirm',
            secondaryBtn: 'Cancel',
            modalConf: tabChangeConf,
        })
        setModalConf(true);
    }
    const tabChangeConf = async () => {
        const payload = {
            tab: 'Driver',
            id: gridSelect.map(op => op.id),
            status: activeTab == 'Active' ? 0 : 1
        }
        // console.log("🚀 ~ tabChangeConf ~ payload:", payload)
        try {
            const res = await withRFSToken.post('vehicle-management/update-activity-status', payload);
            const innerData = res?.data?.response_data;
            if (res.data.response_code === 200) {
                setModalConf(false);
                gridSelect.forEach(item => {
                    const selectedRowBoundIndex = item.boundindex;
                    window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                });
                setGridSelect([])
                window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
            } else {
                toast.error(res.data.response_msg)
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
        }
    }
    const verifiedConf = async (id) => {
        // console.log("hehehehe",confData)
        const payload = {
            id: id,
        }
        try {
            const res = await withRFSToken.post('vehicle-management/update-driver-verify-status', payload);
            const innerData = res?.data?.response_data;
            if (res.data.response_code === 200) {
                setModalConf(false);
                setGridSelect([])
                window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
            } else {
                toast.error(res.data.response_msg)
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
        }
    }
    const confModalClose = () => {
        setModalConf(false);
    }



    return (
        <>
            {modalConf &&
                <ConfModal
                    header={confData.header}
                    subHeader={confData.subHeader}
                    modalConf={confData.modalConf}
                    closeModal={confModalClose}
                    primaryBtn={confData.primaryBtn}
                    secondaryBtn={confData.secondaryBtn}
                />
            }
            {/* <div className="">
                <Header page_type='fsm' logo_url='/DVRegistration/Driver' />
                <div className="page-body-wrapper schedule">

                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <TopMenu module='DVR' /> */}
            {/* <div className="lcontent"> */}
            <div className="mb-1 nestedtabs rounded minh">
                <div className='d-flex justify-content-space-between align-items-center'>
                    <button className="addtruck me-2" variant="primary" onClick={openModal}>
                        <span>Generate Link</span>
                    </button>
                    <button className="addtruck me-2" variant="primary" onClick={openDriverModal}>
                        <span> <FontAwesomeIcon icon={faPlus} /> Add Driver</span>
                    </button>
                    <div className='ulddown'>
                        <button onClick={handleMoveToActArc}> <img title='' src={activeTab == 'Active' ? Arcv : Activ} /> {activeTab == 'Active' ? 'Archive' : 'Active'} </button>
                        <button className="addtruck me-2" variant="primary" onClick={openDownloadModal}><img src={Export} /> Download</button>
                    </div>
                </div>
            </div>
            <div className='maindiv'>
                <div className='trashdonload'>
                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="Active" title={<span> Active </span>} className='moveto'>
                            {!isLoading && <>
                                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                <div ref={gridRefs.Active} className='bookinggrid' ></div>
                            </>
                            }
                        </Tab>
                        <Tab eventKey="Archived" title={<span>Archived </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                        </Tab>
                    </Tabs>
                </div>
            </div>
            <Modal show={linkModal} onHide={closeConfirm} className="addfrom change_type" centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <h3>Generate Link</h3>
                    {dvLink && <><Form.Label>Link</Form.Label>
                        <div className='d-flex'>
                            <Form.Control
                                type="text"
                                ref={inputRef}
                                name="link"
                                value={dvLink || ''}
                                readOnly
                            />
                            <Button onClick={handleCopy} > Copy </Button>
                        </div></>}
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-50 mx-auto are_bottom">
                        <Button variant="secondary" onClick={closeConfirm}> Cancel</Button>
                        <Button variant="primary" onClick={activateLink}> Activate </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={addDriverModal} onHide={closeDriverConfirm} className="addfrom change_type" centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <h3>Driver Registration</h3>
                    <div>
                        <Form className="pt-0">
                            <Form.Group className="mb-3">
                                <Form.Label>Company Name<span className="text-danger">*</span> </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="company_name"
                                    value={driverForm.company_name}
                                    onChange={handleDriverChange}
                                // placeholder="Driver name"
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Driver First Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="first_name"
                                    value={driverForm.first_name}
                                    onChange={handleDriverChange}
                                // placeholder="Driver name"
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Driver Last Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="surname"
                                    value={driverForm.surname}
                                    onChange={handleDriverChange}
                                // placeholder="Driver name"
                                />
                            </Form.Group>
                            <div className='d-flex mb-3'>
                                <Form.Group style={{ width: '40%' }}>
                                    <Form.Label>ID Type <span className="text-danger">*</span></Form.Label>

                                    <InputGroup>
                                        <div className='phone_code'>
                                            <Select
                                                options={idTypeOptions}
                                                // filterOption={filterPhoneOption}
                                                // placeholder="ID Type"
                                                value={idTypeOptions.find(o => o.value === driverForm?.id_type) || null}
                                                onChange={(opt) => {
                                                    setDriverForm(prev => ({
                                                        ...prev,
                                                        id_type: opt ? opt.value : ''
                                                    }));
                                                }}
                                                isClearable
                                            />
                                        </div>
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group style={{ width: '60%' }}>
                                    <Form.Label>ID Expiry <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="id_expiry"
                                        value={driverForm.id_expiry}
                                        onChange={handleDriverChange}
                                    />
                                </Form.Group>
                            </div>

                            {/* License */}
                            <div className='d-flex mb-3'>
                                <Form.Group style={{ width: '50%', margin: '0 10px 0 0' }}>
                                    <Form.Label>License Plate No. <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="license"
                                        value={driverForm.license}
                                        onChange={handleDriverChange}
                                    // placeholder="License plate no."
                                    />
                                </Form.Group>
                                <Form.Group style={{ width: '50%', margin: '0 10px 0 0' }}>
                                    <Form.Label>Trailer ID Plate <span className="text-danger"></span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="trailer_plate"
                                        value={driverForm.trailer_plate}
                                        onChange={handleDriverChange}
                                    // placeholder="Trailer ID Plate"
                                    />
                                </Form.Group>
                            </div>

                            {/* Loading / Unloading */}
                            <Form.Group className="mb-2 mt-1">
                                {/* <Form.Label>Loading/Unloading</Form.Label> */}
                                <div className="d-flex gap-2 addDriverMdl">
                                    <Button
                                        variant={loadingType === "Loading" ? "secondary" : "outline-secondary"}
                                        onClick={() => setLoadingType("Loading")}
                                        style={{ flex: 1 }}
                                        className="loading_unloading_btn"
                                    >
                                        <img src={loading_icon} alt='loading' className='loading_icon pe-2' />
                                        Loading
                                    </Button>
                                    <Button
                                        variant={loadingType === "Unloading" ? "secondary" : "outline-secondary"}
                                        onClick={() => setLoadingType("Unloading")}
                                        style={{ flex: 1 }}
                                        className="loading_unloading_btn"
                                    >
                                        <img src={unloading_icon} alt='unloading' className='loading_icon pe-2' />
                                        Unloading
                                    </Button>
                                </div>
                            </Form.Group>
                            <Form.Group className='mt-3 mb-2'>
                                <Form.Label>Document Reference <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="cmr"
                                    value={driverForm.cmr}
                                    onChange={handleDriverChange}
                                // placeholder="CMR Reference Number"
                                />
                            </Form.Group>

                            <div className="submit_cancel_btn">
                                <div className="d-flex" style={{ gap: "10px" }}>
                                    <Button onClick={handleDriverSubmit} variant="primary" className="w-100 mt-0">
                                        Submit
                                    </Button>
                                </div>
                            </div>

                        </Form>
                    </div>
                </Modal.Body>
            </Modal>

            {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}>
                    <span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span>
                </div>
            }
            {downloadModal && (
                <DownloadGrid onClose={closeDownloadModal} tabName={'Driver'} />
            )}
            <Modal show={editModal} onHide={() => setEditModal(false)} centered className="addfrom change_type">
                <Modal.Header closeButton>
                    <Modal.Title>Edit {selectedField === "checkin_date" ? "Date Time In" : "Date Time Out"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Select Date & Time</Form.Label>
                        <Form.Control
                            type="datetime-local"
                            value={dateTimeValue}
                            onChange={(e) => setDateTimeValue(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={saveDateTime}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal
                className="addfrom change_type"
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <h3>Signature Info</h3>
                    <p className='mb-3'>To View This Signature. <br /> Please Contact Cargohub <b>Support Team</b></p>
                </Modal.Body>
            </Modal>
            {/* </div> */}
        </>
    )
}


export default Driver